/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-02-23",
    versionChannel: "nightly",
    buildDate: "2024-02-23T00:05:28.155Z",
    commitHash: "d2e854fb732f4356625f2726d2b62641aba0cc6e",
};
